import React, {Component, PropTypes} from 'react';
import {Icon} from 'antd'
import Animate from 'rc-animate'

class SideModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      closed: true,
      enter: props.visible
    }
  }
  static defaultProps = {
    visible: false
  }
  closeHandle = () => {
    this.setState({enter: false})
    const onClose = this.props.onClose
    if (onClose) onClose()
    
  }
  componentWillReceiveProps(nextProps) {
    //  && !this.props.visible
    if ('visible' in nextProps) {
      this.setState({enter: nextProps.visible})
    }
  }
  // componentDidMount() {
  // }
  toggleAnimate = () => {
    this.setState({enter: !this.state.enter});
  }
  animationEnd = () => {
    const {enter} = this.state
    
    this.setState({closed: !enter})
  }
  render() {
    const {closed, enter} = this.state
    const {title = '标题'} = this.props
    return (
        <Animate 
          component=""
          showProp='data-show'
          onEnd={this.animationEnd}
          transitionName="bounce-right">
          <div data-show={this.state.enter} className={'side-modal-w'} style={{display: !this.state.closed ? 'block' : 'none'}}>
            <span className="icon" onClick={this.closeHandle}><Icon type="close"/></span>
            <div className="side-modal-c">
              <div className="side-modal-header">
                {title}
              </div>
              <div className="side-modal-content">
                {this.props.children}
              </div>
            </div>
          </div>
        </Animate>
    )
  }
}
export default SideModal





// WEBPACK FOOTER //
// ./src/components/common/SideModal/index.js